import React from "react";
import { connect } from "react-redux";
import { fetchAggregatorCollections } from "../../queries/aggregatorCollections/aggregatorCollectionQuery";
import language from "../../language";
import handleSearch from "../../utils/handleSearch";
import { Table } from "../Table";
import { Modal } from "../Modal";
import NewAggregatorCollection from "./NewAggregatorCollection";

let copyData = [];

class Collections extends React.Component {
  state = {
    isLoading: false,
    selected_data: {},
    data: [],
  };

  componentDidMount() {
    this.getData(true);
  }

  getData = async (isLoading) => {
    const { defaultLanguage, aggregatorId } = this.props;
    try {
      this.setState({ isLoading });

      const data = await fetchAggregatorCollections(defaultLanguage, {
        aggregatorId,
        active: true,
      });

      this.setState({
        isLoading: false,
        data,
      });

      copyData = data.slice(0);
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  handlePagination(page) {
    this.setState(
      {
        page,
      },
      () => {
        this.getData(true);
      }
    );
  }

  handleShowModal(modal, modalTitle, selected_data = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selected_data,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].identifier,
        key: "identifier",
      },
      {
        title: language[this.props.defaultLanguage].name,
        key: "name",
      },
      {
        title: language[this.props.defaultLanguage].active,
        key: "active",
      },
    ];

    return headers;
  }

  render() {
    console.log(this.props);
    return (
      <>
        <Table
          data={this.state.data}
          isSearch
          page={this.state.page}
          limit={this.state.limit}
          showAdd={this.props.showAdd}
          addButtonText={language[this.props.defaultLanguage].add_collection}
          totalPageCount={this.state.totalPageCount}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          headers={this.returnTableHeaders()}
          handleAddPressed={this.handleShowModal.bind(
            this,
            "showModal",
            language[this.props.defaultLanguage].aggregator
          )}
          search_text={this.state.search_text}
          handleSearch={(e) =>
            handleSearch(this, { copyData, value: e.target.value })
          }
        />
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showModal")}
          show={this.state.showModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
        >
          <NewAggregatorCollection
            aggregatorId={this.props.aggregatorId}
            aggregatorName={this.props.aggregatorName}
            handleCloseModal={this.handleCloseModal.bind(this, "showModal")}
            getData={this.getData.bind(this)}
            {...this.state.selected_data}
          />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(Collections);
